module.exports = __webpack_public_path__ + "img/gzh.2321ca60.jpg";